import Vue, { VueConstructor } from 'vue'
import Announcements from '@/components/announcements/Announcements.vue'
import TopPageAnnouncementInfo from '@/components/announcements/TopPageAnnouncementInfo.vue'
import { Announcement } from '@/types/announcements'
import { getJsonData } from '@/utils/dom'

// @ts-ignore
import { SYSTEM_ERROR } from '@/utils/const'

const getAnnouncements = (): Promise<Announcement[]> => {
  return new Promise(resolve => {
    const data = getJsonData('#json-announcements')
    resolve(data)
  })
}

// Mount vue components
const mountAnnouncementEl = document.querySelector<HTMLElement>(
  '#js-announcements-app'
)

const mountTopPageAnnouncementInfoEl = document.querySelector<HTMLElement>(
  '#js-announcementsInfo-topPage-app'
)

const mountAnnouncementsApp = (
  mountEl: HTMLElement,
  component: VueConstructor<Vue>,
  announcements: Announcement[]
) => {
  if (!mountEl) {
    return false
  }

  new Vue({
    render: h =>
      h(component, {
        props: {
          announcements: announcements
        }
      })
  }).$mount(mountEl)
}


getAnnouncements()
  .then(announcements => {
    if (mountAnnouncementEl) {
      mountAnnouncementsApp(mountAnnouncementEl, Announcements, announcements)
    }
    if (mountTopPageAnnouncementInfoEl)
      mountAnnouncementsApp(mountTopPageAnnouncementInfoEl, TopPageAnnouncementInfo, announcements
      )
  })
  .catch(() => {
    window.alert(SYSTEM_ERROR.UNKNOWN)
  })
